module.exports = __webpack_public_path__ + "248c7e4033092d4cf73eb3c3d8b54c18.png";